var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDialogVisible
    ? _c(
        "el-dialog",
        {
          attrs: {
            visible: true,
            title: "Quick Group Message",
            "close-on-click-modal": false,
          },
          on: { close: _vm.onFormClose },
        },
        [
          _vm.isFormBusy ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("quick-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isFormBusy,
                expression: "!isFormBusy",
              },
            ],
            attrs: {
              "is-initialized": _vm.isInitialized,
              "get-form-url": _vm.getFormUrl,
              "excluded-conversation-ids": _vm.excludedConversationIds,
            },
            on: {
              formInitialized: this.onFormInitialized,
              formInitializationError: this.onFormInitializationError,
              created: _vm.onCreated,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }